export default __webpack_public_path__ + "e923c63a6936922f6267fafa09c7fa50.png";